module.exports = __webpack_public_path__ + "static/media/marketing-color.76cd2f62.png";